import React from "react";
import { Provider } from "react-redux";
import { createReduxStore } from "../store";
import reducer from "./redux/challengerConversionReducer";
import saga from "./redux/challengerConversionSaga";

import ChallengerConversionModule from "./ChallengerConversionModule";
import ErrorBoundary from "../../../../components/errorBoundary/errorBoundary";

const ChallengerConversion = (props) => {
  return (
    <Provider store={createReduxStore("challengerConversion", reducer, saga)}>
      <ErrorBoundary moduleName="challengerConversion">
        <ChallengerConversionModule params={props} {...props.notifications}/>
      </ErrorBoundary>
    </Provider>
  );
};

export default ChallengerConversion;
